<script lang="ts">
    import Date from 'hydria/components/Date.svelte'
    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'
    import { gettext as _ } from 'hydria/services/gettext'

    import type { AdminUser, UserStatus } from './user'

    interface Props {
        user: AdminUser;
        status: UserStatus;
    }

    let { user, status }: Props = $props();
</script>

<div class="card flex-fill">
    <div class="card-header text-bg-primary">{$_('User information')}</div>

    <div class="card-body">
        <dl>
            <dt>{$_('Full name')}</dt>
            <dd>
                {#if status == 'loading'}
                    <LoadingPattern pattern={[25]} />
                {:else}
                    {user.metadata.name ? user.metadata.name : '–'}
                {/if}
            </dd>

            <dt>{$_('Email address')}</dt>
            {#if status == 'loading'}
                <LoadingPattern pattern={[45]} />
            {:else}
                {user.email}
            {/if}
        </dl>

        <dl>
            <dt>{$_('Creation date')}</dt>
            <dd>
                {#if status == 'loading'}
                    <LoadingPattern pattern={[30]} />
                {:else}
                    <Date value={user.ctime} format="h-table-s" />
                {/if}
            </dd>

            <dt>{$_('Modification date')}</dt>
            <dd>
                {#if status == 'loading'}
                    <LoadingPattern pattern={[30]} />
                {:else}
                    <Date value={user.mtime} format="h-table-s" />
                {/if}
            </dd>

            <dt>{$_('Last sign in')}</dt>
            <dd>
                {#if status == 'loading'}
                    <LoadingPattern pattern={[30]} />
                {:else}
                    <Date value={user.last_signed_in} format="h-table-s" />
                {/if}
            </dd>
        </dl>
    </div>
</div>
